import {Box} from '@mui/joy';
import {SideBySideLayout} from "@/components/layouts/SideBySideLayout.jsx";
import {Logo} from "@/components/Logo.jsx";
import {OnboardingTip} from "@/components/OnboardingTip.jsx";

export function AuthLayout({children}) {
  return <SideBySideLayout left={
      <>
        <Box component="header" sx={{pl: {xs: 0, lg: 4.25}, py: {xs: 2, lg: 4.3}}}>
          <Logo />
        </Box>
        <Box
          component="main"
          sx={{
            my: 'auto',
            py: 2,
            pb: 7,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            width: 400,
            maxWidth: '100%',
            mx: 'auto',
            borderRadius: 'sm',
          }}
        >
          {children}
        </Box>
      </>
    }
    right={
      <OnboardingTip
        title="Plan your meals and groceries."
        subtitle="Import your recipes from your favorite recipe websites and create your own recipes."
      />
    }
  />;
}